import React from "react";
import { Col, Row } from "react-bootstrap";

const programTags = [
  "Private Label",
  "Laundry Sheets",
  "Custom Fragrance",
  "Fragrance Free",
  "Fresh Linen",
  "Paper Packaging",
  "Retail Ready",
  "MOQ starts at 1,000 retail package units per SKU",
  "Sample Support",
  "Dieline Support",
  "Formula Review",
  "Quality Inspection",
  "Logistics Support",
  "Columbus Ohio",
  "Wholesale Programs",
  "Refill Programs",
];

function Techstack() {
  return (
    <Row className="program-tags">
      {programTags.map((tag) => (
        <Col xs={6} md={3} lg={2} className="tech-icons" key={tag}>
          {tag}
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
